import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DwFormField from '@ui/formfield/DwFormField';
const BookAnAppointmentPersonalInfo = (props) => {
    const { t } = useTranslation();
    const { formdef, hideTitle } = props;
    const isJp = window.country == 'JP';
    const insideHideTitle = isJp ? isJp : hideTitle;
    const classNames = useMemo(() => (insideHideTitle ? 'col-24 col-lg-12' : 'col-24 col-lg-8'), [insideHideTitle]);
    const renderTitle = () => (React.createElement("div", { className: classNames },
        React.createElement(DwFormField, { def: formdef, name: "title", type: formdef['title'].options ? 'select' : 'text', autocomplete: "honorific-prefix" })));
    const renderFirstname = () => (React.createElement("div", { className: classNames },
        React.createElement(DwFormField, { def: formdef, name: "firstname", autocomplete: "given-name", readonly: props.readonly })));
    const renderLastname = () => (React.createElement("div", { className: classNames },
        React.createElement(DwFormField, { def: formdef, name: "lastname", autocomplete: "family-name", readonly: props.readonly })));
    const renderNames = () => isJp ? (React.createElement(React.Fragment, null,
        renderLastname(),
        renderFirstname())) : (React.createElement(React.Fragment, null,
        renderFirstname(),
        renderLastname()));
    return !insideHideTitle ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            renderTitle(),
            renderNames()))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" }, renderNames())));
};
export default BookAnAppointmentPersonalInfo;
